<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div class="font-18-30313a font-bold">客户投诉</div>
          <div class="line"></div>
          <div>
            <div><span>客户信息：</span>{{info.name}}</div>
            <div><span>装修地址：</span>{{info.detailedAddress}}</div>
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7 h-0">
        <div class="flex mb-10">
          <div class="title flex align-center bg-ff flex-1">
            <div class="flex align-center mr-20 cursor" v-for="(item, index) in tab" :key="index" @click="switchTab(index + 1)">
              <div class="mr-5" :class="index + 1 === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
              <div class="font-bold" :class="index + 1 === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{item}}</div>
            </div>
          </div>
        </div>
        <div class="addBtn cursor mb-10" @click="addComplaint" v-if="tabIndex === 1 && permission.indexOf('customerComplaintBasic') !== -1">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>新增投诉</div>
        </div>
        <div class="flex-1 complaintList mb-10 h-0">
          <el-scrollbar style="height: 100%;">
            <div class="flex planItem" v-for="(item, index) in handleList" :key="index">
              <div class="flex-1 main">
                <div class="flex justify-space-between">
                  <div v-if="tabIndex === 1">
                    <div class="font-12-85 mb-2"><span>投诉时间</span>{{item.foundName}} {{Utils.formatTime2(item.createTime)}}</div>
                    <div class="font-12-85 mb-2 mb-8">
                      <span style="color: #ff5555;">待处理人</span>{{executorList(item.handlerList)}}
                    </div>
                  </div>
                  <div v-else>
                    <div class="font-12-85 mb-2"><span>投诉时间</span><i style="font-style: normal; color: #ff5555;">客户</i> {{item.foundName}} {{Utils.formatTime2(item.planTime)}}</div>
                    <div class="font-12-85 mb-2 mb-8"><span>处理人员</span>{{executorList(item.handlerList)}}</div>
                  </div>
                  <div class="flex" v-if="tabIndex === 1 && permission.indexOf('customerComplaintBasic') !== -1">
                    <button class="btn-16-bd-85 mr-5" @click="toChangeHandler(item)">换处理人</button>
                    <button class="btn-16-bg-46b8b0 mr-5" @click="toHandle(item)" v-if="item.canHandle">立即处理</button>
                    <!--<button class="btn-16-bg-85 mr-5" @click="toHandleFinish(item)" v-if="!item.delete && item.canHandle">处理完成</button>-->
                    <button class="btn-16-bd-ff5555" @click="toDelete(item)" v-if="item.delete">删除</button>
                  </div>
                </div>
                <div class="flex">
                  <span>投诉内容</span>
                  <div class="flex-1">
                    <div class="font-12-30313a mb-10">{{item.content}}</div>
                    <div class="flex flex-wrap" v-if="item.photoList.length > 0">
                      <div v-for="(pic, j) in item.photoList" :key="j" class="mr-10 mb-10">
                        <viewer :images="item.photoList">
                          <img style="width: 90px; height: 90px" :src="Utils.IMG_PREV + pic.path" fit="cover">
                        </viewer>
                      </div>
                    </div>
                    <div class="handle" v-if="item.resultList.length > 0">
                      <div class="handleHd flex align-center">
                        <div class="font-14-424142 font-bold mr-5">处理详情</div>
                        <div :class="tabIndex === 1 ? 'status1' : 'status2'">{{tabIndex === 1 ? '处理中' : '处理完成'}}</div>
                      </div>
                      <div class="">添加处理结果</div>
                      <div class="hr"></div>
                      <div class="plr-16">
                        <div class="handleItem" v-for="(handleItem, i) in item.resultList" :key="i">
                          <div class="pt-12 pb-2 plr-12">
                            <div class="font-12-85 mb-5 itemTitle">{{handleItem.handlerName}} {{Utils.formatTime2(handleItem.createTime)}}</div>
                            <div class="font-12-30313a mb-10">{{handleItem.content}}</div>
                            <div class="flex">
                              <div v-for="(handlePic, k) in handleItem.photoList" :key="k" class="mr-10 mb-10">
                                <viewer :images="handleItem.photoList">
                                  <img style="width: 90px; height: 90px" :src="Utils.IMG_PREV + handlePic.path" fit="cover">
                                </viewer>
                              </div>
                            </div>
                          </div>
                          <div class="hr-dashed" v-if="i < item.resultList.length - 1"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
    </el-main>
    <!--新增-->
    <el-dialog title="新增投诉" :visible.sync="addVisible" width="530px" class="addComplaint">
      <div class="p-20">
        <el-form ref="form" :model="add" class="mb-70">
          <el-form-item>
            <div class="flex">
              <div class="font-12-30313a"><span style="display:inline-block; width: 10px; color: #ff5555;">*</span>填写投诉内容：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="add.content" resize="none"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex align-center">
              <div class="font-12-30313a"><span style="display:inline-block; width: 10px; color: #ff5555;">*</span>选择处理人员：</div>
              <div class="flex-1 chooseHandle flex align-center justify-space-between plr-10" @click="chooseHandler">
                <div class="flex-1 w-0 text-left">
                  <div class="font-12-b9b9b9" v-if="projectMemberStr === ''">请在该项目的成员和问题处理人员内选择</div>
                  <div class="font-12-30313a" v-else>{{projectMemberStr}}</div>
                </div>
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <div class="flex">
              <div class="font-12-30313a"><span style="display:inline-block; width: 10px; height: 1px;"></span>添加投诉照片：</div>
              <div>
                <el-upload
                  class="text-left"
                  multiple
                  name="file"
                  :httpRequest="httpRequestImg"
                  :action="upload"
                  :show-file-list="false"
                  :before-upload="beforeImgUpload">
                  <div class="addBtn cursor mb-10 button">
                    <img src="/static/images/customer/chubeikehu.png" alt="">
                    <div>上传图片</div>
                  </div>
                </el-upload>
                <div class="flex flex-wrap ">
                  <div class="picItem mr-10 mb-10 relative" v-for="(item, index) in add.pic" :key="index">
                    <el-image :src="Utils.IMG_PREV + item.path" alt="" fit="cover" style="width: 100%; height: 100%;"></el-image>
                    <img src="/static/images/removeImg.png" class="absolute removeIcon" alt="" @click="removePic(index)">
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10" @click="onCloseAdd">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="onSubmitAdd">确定</div>
      </div>
    </el-dialog>
    <!--执行服务计划-->
    <choose-handler ref="chooseHandler" :id="id" :flag="handlerFlag" :handleId="handleId"></choose-handler>
    <to-handle ref="toHandle" :handleId="handleId" :type="handleType"></to-handle>
    <finish-handle ref="finishHandle" :handleId="handleId" :type="handleType"></finish-handle>
  </el-container>
</template>

<script>
import ChooseHandler from './components/ChooseHandler'
import ToHandle from './components/ToHandle'
import FinishHandle from './components/FinishHandle'
import Pagination from '../../components/Pagination'
export default {
  name: 'customerComplaint',
  components: {ChooseHandler, ToHandle, FinishHandle, Pagination},
  data () {
    return {
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      id: null,
      parent: null,
      info: {},
      tabIndex: 1,
      tab: ['未处理投诉', '已处理投诉'],
      addVisible: false,
      add: {
        handlerParamList: [],
        pic: [],
        content: ''
      },
      projectMemberStr: '',
      handleId: null,
      page: 1,
      limit: 25,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 25,
      total: 0,
      handleList: [],
      handlerFlag: false,
      handleType: 1,
      permission: []
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
    this.getInfo()
    this.getHandleList()
    this.getPermission()
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'customerComplaint',
        parentGroup: 'customerComplaint'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
        }
      })
    },
    getHandleList () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerHandle/queryForPage`, {
        customerId: this.id,
        page: this.page,
        limit: this.limit,
        type: 2,
        status: this.tabIndex
      }).then(res => {
        if (res.data.success) {
          this.handleList = []
          res.data.data.list.forEach(i => {
            i.active = false
            this.handleList.push(i)
          })
          this.$refs.chooseHandler.getProjectMember()
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    executorList (list) {
      let arr = []
      list.forEach(i => {
        arr.push(i.name + ' / ' + i.telephone)
      })
      return arr.join('、')
    },
    switchTab (index) {
      this.tabIndex = index
      this.getHandleList()
    },
    addComplaint () {
      this.addVisible = true
    },
    onSubmitAdd () {
      if (this.add.content === null || this.add.content === '') {
        this.$message({
          message: '请填写投诉内容',
          type: 'warning'
        })
      } else if (this.add.handlerParamList.length === 0) {
        this.$message({
          message: '请选择处理人员',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerHandle/save`, {
          customerId: this.id,
          content: this.add.content,
          handlerParamList: this.add.handlerParamList,
          photoParamList: this.add.pic,
          type: 2
        }).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.onCloseAdd()
            this.getHandleList()
            this.$refs.chooseHandler.onReset()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onCloseAdd () {
      this.addVisible = false
      this.add = {
        handlerParamList: [],
        pic: [],
        content: ''
      }
    },
    beforeImgUpload () {},
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 4)
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.add.pic.push({path: onloadRes.data.data.path})
        }
      }).catch(() => {
        this.$message.error('上传失败3！')
      })
    },
    removePic (index) {
      this.add.pic.splice(index, 1)
    },
    chooseHandler () {
      this.handlerFlag = false
      this.$refs.chooseHandler.chooseHandlerVisible = true
    },
    toChangeHandler (item) {
      this.handlerFlag = true
      this.handleId = item.id
      this.$refs.chooseHandler.selectedList = this.Utils.deepClone(item.handlerList)
      this.$refs.chooseHandler.projectMemberStr = this.executorList(item.handlerList)
      this.$nextTick(() => {
        this.$refs.chooseHandler.chooseHandlerVisible = true
      })
    },
    toHandle (item) {
      this.handleId = item.id
      this.handleType = 1
      this.$refs.toHandle.handleVisible = true
    },
    // toHandleFinish (item) {
    //   this.handleId = item.id
    //   this.handleType = 2
    //   this.$refs.finishHandle.returnResultVisible = true
    // },
    toDelete (item) {
      this.$confirm('此操作将删除该计划, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerHandle/deleteById`, this.qs.stringify({
          id: item.id
        })).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getHandleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onClose () {
      this.$router.go(-1)
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getHandleList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-main{
    padding: 0;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 0 12px;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 20px;
    border-radius: 4px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .w-340{
    width: 340px;
  }
  .complaintList{
    text-align: left;
    overflow-y: auto;
  }
  .complaintList span{
    font-size: 12px;
    color: #b9b9b9;
    margin-right: 10px;
  }
  .planItem{
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .planItem .main{
    padding: 15px;
  }
  .planItem .right{
    padding: 10px;
  }
  .complaintList /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .addComplaint /deep/ .el-form-item{
    margin-bottom: 10px;
  }
  .addComplaint /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 150px;
  }
  .handlePlan /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 240px;
  }
  .finishItem{
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .finishItem .top{
    padding: 10px;
  }
  .finishItem .bottom{
    border-top: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  }
  .finishItem .bottom > div{
    width: 80px;
    height: 20px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .finishItem .center{
    border-top: 1px solid #e2e2e2;
  }
  .finishItem .center .list{
    padding:15px;
  }
  .finishItem .center .listItem{
  }
  .expand-enter-active {
    transition: max-height 7s;
    overflow: hidden;
    max-height: 7777px;
  }
  .expand-enter {
    max-height: 0;
  }
  .handle{
    background: #f3f4f7;
    border-radius: 4px;
  }
  .handleHd {
    padding: 12px;
  }
  .status1{
    height: 16px;
    background: #82b925;
    border-radius: 8px;
    padding:  0 6px;
    font-size: 12px;
    color: #fff;
  }
  .status2{
    height: 16px;
    background: #858585;
    border-radius: 8px;
    padding:  0 6px;
    font-size: 12px;
    color: #fff;
  }
  .handleItem{
    border-left: 2px solid #e2e2e2;
  }
  .itemTitle{
    position: relative;
  }
  .itemTitle:before{
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #b9b9b9;
    border: 2px solid #f3f4f7;
    position: absolute;
    left: -18px;
    top:4px;
  }
  .chooseHandle{
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    cursor: pointer;
  }
  .button{
    border: 1px solid #e2e2e2;
  }
  .picItem{
    width: 70px;
    height: 70px;
  }
  .removeIcon{
    top:5px;
    right: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/customerComplaint.vue